import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=077767cc&scoped=true&"
import script from "./WechatLogin.vue?vue&type=script&lang=js&"
export * from "./WechatLogin.vue?vue&type=script&lang=js&"
import style1 from "./WechatLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077767cc",
  null
  
)

export default component.exports